/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";
import {
  AgentPolicySelector,
  AgentPolicySelector$Outbound,
  AgentPolicySelector$outboundSchema,
} from "./agentpolicyselector.js";

/**
 * Grant effect
 */
export const ExtendAgentKeyGrantFormEffect = {
  Allow: "allow",
} as const;
/**
 * Grant effect
 */
export type ExtendAgentKeyGrantFormEffect = ClosedEnum<
  typeof ExtendAgentKeyGrantFormEffect
>;

/**
 * The grant's scope
 */
export const ExtendAgentKeyGrantFormScope = {
  McpConnect: "mcp:connect",
} as const;
/**
 * The grant's scope
 */
export type ExtendAgentKeyGrantFormScope = ClosedEnum<
  typeof ExtendAgentKeyGrantFormScope
>;

/**
 * A server grant an agent key gains. Anything broader is a new delegation, made by issuing a key.
 */
export type ExtendAgentKeyGrantForm = {
  /**
   * Grant effect
   */
  effect: ExtendAgentKeyGrantFormEffect;
  /**
   * The grant's scope
   */
  scope: ExtendAgentKeyGrantFormScope;
  /**
   * A constraint that narrows which resources an agent grant applies to.
   */
  selector: AgentPolicySelector;
};

/** @internal */
export const ExtendAgentKeyGrantFormEffect$outboundSchema: z.ZodMiniEnum<
  typeof ExtendAgentKeyGrantFormEffect
> = z.enum(ExtendAgentKeyGrantFormEffect);

/** @internal */
export const ExtendAgentKeyGrantFormScope$outboundSchema: z.ZodMiniEnum<
  typeof ExtendAgentKeyGrantFormScope
> = z.enum(ExtendAgentKeyGrantFormScope);

/** @internal */
export type ExtendAgentKeyGrantForm$Outbound = {
  effect: string;
  scope: string;
  selector: AgentPolicySelector$Outbound;
};

/** @internal */
export const ExtendAgentKeyGrantForm$outboundSchema: z.ZodMiniType<
  ExtendAgentKeyGrantForm$Outbound,
  ExtendAgentKeyGrantForm
> = z.object({
  effect: ExtendAgentKeyGrantFormEffect$outboundSchema,
  scope: ExtendAgentKeyGrantFormScope$outboundSchema,
  selector: AgentPolicySelector$outboundSchema,
});

export function extendAgentKeyGrantFormToJSON(
  extendAgentKeyGrantForm: ExtendAgentKeyGrantForm,
): string {
  return JSON.stringify(
    ExtendAgentKeyGrantForm$outboundSchema.parse(extendAgentKeyGrantForm),
  );
}
